import { Box } from '@lingoda/ui';
import { colorsPalette, styled } from '@lingoda/ui/theme';

export const StudentCreditsBox = styled(Box)(({ theme }) => ({
    color: colorsPalette.primarySolid[100],
    border: `1px solid ${colorsPalette.blackAlpha[20]}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
}));
